import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Page from "../../ui/page/Page";
import pathRouts from "../../../enums/pathRoute";
import iconsList from "../../ui/icons/iconsList";
import useIframeParams from "../../../hooks/useIframeParams";
import { appendIframeParamsToUrl } from "../../../utils/iframeParamsUtils";
import classes from "./IframePage.module.css";

const IframePage = ({ iframeUrl, iframeParams, titleKey, icon, onBack }) => {

  const navigate = useNavigate();
  const { texts } = useSelector(state => state.translate);
  const queryParams = useIframeParams(iframeParams);
  const handleBack = onBack || (() => navigate(`/${pathRouts.HOME}`));

  return (
    <Page title={texts[titleKey]} icon={iconsList[icon]} onBack={handleBack} pageClassName={classes.IframePage} className={classes.IframePageContent}>
      <iframe
        className={classes.Iframe}
        src={appendIframeParamsToUrl(iframeUrl, queryParams)}
        title={texts[titleKey]}
      />
    </Page>
  );
}

export default IframePage;
